import angular from 'angular';
import PdfModalModule from './pdf-modal/pdf-modal';

const ComponentsModule = angular.module('control-room.commons.content.components.pdf-uploader.components', [
    PdfModalModule.name,
]);

export default ComponentsModule;
